module.exports = __webpack_public_path__ + "static/madhur-profile.dfbc77a4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/madhur-profile.png
// module id = 343
// module chunks = 144251824217401